"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeImpl = void 0;
function isTypeImpl(key) {
    function isType(instanceOrType, type) {
        if (instanceOrType != undefined) {
            if (typeof instanceOrType === 'function' || typeof instanceOrType === 'string') {
                const typeArg = instanceOrType;
                const typeStr = typeof typeArg === 'string' ? typeArg : typeArg.output.type;
                return (o) => isType(o, typeStr);
            }
            else {
                const instance = instanceOrType;
                const typeStr = typeof type === 'string' ? type : type.output.type;
                return instance != undefined && instance[key !== null && key !== void 0 ? key : 'type'] === typeStr;
            }
        }
        else {
            return false;
        }
    }
    return { isType };
}
exports.isTypeImpl = isTypeImpl;
